import React from "react";
import { Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useContinuousAppointmentsByPatient } from "../../../stores/Appointment/appointment.queries";
import TerminView from "../../../components/PatientOverview/RxInfo/TerminView";
import { TerminViewConstants } from "../../../components/PatientOverview/TerminView";
import { DrawerCard, DrawerCardSpinner } from "./DrawerCard";

interface ContinuousAppointmentCardProps {
  patientId: number;
}

const ContinuousAppointmentCard: React.FC<ContinuousAppointmentCardProps> = observer(
  ({ patientId }) => {
    const { data: continuousAppointments, isLoading, error } = useContinuousAppointmentsByPatient(patientId);

    const scheduledContinuousApps = (continuousAppointments || []).filter(
      (appointment) => appointment.start
    );

    if (isLoading) {
      // No reserved height, unlike Terminkontext: this list has no fixed
      // shape (a patient may have one Dauertermin or none), so guessing a
      // height would just swap the grow for a shrink.
      return (
        <DrawerCard title="Dauertermine">
          <DrawerCardSpinner />
        </DrawerCard>
      );
    }

    if (error) {
      return (
        <DrawerCard title="Dauertermine">
          <Typography color="error">Fehler beim Laden der Dauertermine</Typography>
        </DrawerCard>
      );
    }

    return (
      <DrawerCard title="Dauertermine">
        <TerminView
          appointments={scheduledContinuousApps}
          patientId={patientId}
          appointmentsLoading={isLoading}
          isView={TerminViewConstants.CONTINOUS_TERMIN}
          isContinuous={true}
        />
      </DrawerCard>
    );
  }
);

export default ContinuousAppointmentCard;
